import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './list-selectable.styl'

export default class ListSelectable extends Component {
  static propTypes = {
    list: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      activeId: null
    }
  }

  handleSetActive = activeId => this.setState({ activeId })

  render() {
    const { list, onChange } = this.props
    const { activeId } = this.state

    return (
      <ul className={styles.list}>
        {list.map(item => {
          const activeClass = activeId === item.id ? styles.active : ''

          return (
            <li key={item.id} className={`${styles.item} ${activeClass}`}>
              <span className={`ico ico--checked ${styles.ico}`} />
              <button
                className={styles.btn}
                type="button"
                onClick={() => {
                  onChange(item)
                  this.handleSetActive(item.id)
                }}
              >
                {item.person.firstName} {item.person.lastName}
              </button>
            </li>
          )
        })}
      </ul>
    )
  }
}
